import { normalizeDatetimeForWrite } from "@/lib/utils/normalizeDatetimeForWrite";
import { WriteTimesheetEntry } from "@/types/timesheetEntry";

/**
 * Normalizes both datetimes before PATCH so untouched fields are not left in
 * UTC and every payload uses offset-aware ISO strings.
 */
export const normalizeWriteTimesheetEntryDatetimes = <
  T extends Pick<WriteTimesheetEntry, "start_datetime" | "end_datetime">,
>(
  entry: T,
): T => ({
  ...entry,
  start_datetime: normalizeDatetimeForWrite(entry.start_datetime),
  end_datetime: normalizeDatetimeForWrite(entry.end_datetime),
});
